import { IInvoiceServiceCharge } from '../invoices.model';
import { InvoiceValidationError } from './types';

export enum InvoiceTabEnum {
  BILL_TO = 'Bill to',
  INVOICE_OPTIONS = 'Invoice options',
  LINE_ITEMS = 'Line items',
  LINE_ITEMS_INPUT = 'LINE_ITEMS_INPUT',
  NOTES_ATTACHMENTS = 'Notes & Attachments',
  PAYMENT_OPTIONS = 'Payment options',
  PAYMENT_REMINDERS = 'Payment reminders',
  MORE_OPTIONS = 'More Options'
}

export const USPincodeRegex = new RegExp('^\\d{5}(?:[-\\s]\\d{4})?$');
export const emailRegex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[c\\w-]{2,4}$');

export enum InvoiceValidationErrorType {
  MIN_LINE_ITEM = 'minLineItem'
}

export const minimumLineItemsError: InvoiceValidationError = {
  type: InvoiceValidationErrorType.MIN_LINE_ITEM,
  errorMsg: 'Line Item is missing'
};

export const initServiceCharge: IInvoiceServiceCharge = {
  id: null,
  name: '',
  amount: '',
  percentage: '',
  taxes: [],
  totalAmount: ''
};

export enum InfoType {
  ERROR = 'ERROR',
  WARN = 'WARN'
}

// Firebase field name constants for auto-fill feature flags
export enum FIREBASE_FIELD {
  INVOICE_AUTOFILL_MODAL = 'hasSeenInvoiceAutoFillFeatureModal',
  INVOICE_AUTOFILL_BANNER = 'hasSeenInvoiceAutoFillFeatureBanner'
}
